<template>
  <section>
    <v-dialog
      v-model="modalAction"
      max-width="600px"
      scrollable
      @keydown="executeCloseModalFilterDocuments"
      @click:outside="executeCloseModalFilterDocuments"
    >
      <v-card>
        <div class="p-4 pb-0">
          <h5>Filtros de Documentos</h5>
        </div>
        <hr />
        <v-card-text>
          <v-row class="px-4 mt-3">
            <v-col cols="12" md="12" sm="12" class="">
              <v-text-field
                label="Búsqueda"
                v-model="filters.filter"
                clearable
                outlined
                hide-details
                placeholder="Filtro de Búsqueda"
              ></v-text-field>
              <div class="mt-3 d-flex align-items-center justify-content-start">
                <v-checkbox
                  @change="validateCheckFilter('folders')"
                  v-model="filters.onlyFolders"
                  class="mt-0"
                >
                  <template v-slot:label>
                    <h6 class="mt-2 mb-0">Carpetas</h6>
                  </template>
                </v-checkbox>
                <v-checkbox
                  @change="validateCheckFilter('subfolders')"
                  v-model="filters.onlySubFolders"
                  class="mt-0 mx-5"
                >
                  <template v-slot:label>
                    <h6 class="mt-2 mb-0">Subcarpetas</h6>
                  </template>
                </v-checkbox>
                <v-checkbox
                  @change="validateCheckFilter('name_documents')"
                  v-model="filters.onlyNameDocuments"
                  class="mt-0"
                >
                  <template v-slot:label>
                    <h6 class="mt-2 mb-0">Nombres de Documentos</h6>
                  </template>
                </v-checkbox>
              </div>
            </v-col>
            <v-col cols="12" md="12" sm="12" class="pt-0">
              <v-autocomplete
                v-model="filters.assigned_area_filter"
                :items="assignedAreas"
                item-text="name"
                item-value="name"
                label="Área Responsable"
                clearable
                class="mt-2"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="12" sm="12" class="mt-4 pt-0">
              <v-menu
                ref="menu"
                v-model="datepicker_menu_start"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date_start_formatted"
                    prepend-icon="mdi-calendar"
                    readonly
                    label="Fecha (desde)"
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    @click:clear="clearDateFilters"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filters.date_start"
                  scrollable
                  locale="es"
                  :max="maxDateStart"
                  @input="datepicker_menu_start = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="12" sm="12" class="pt-0">
              <v-menu
                ref="menu"
                v-model="datepicker_menu_end"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date_end_formatted"
                    prepend-icon="mdi-calendar"
                    readonly
                    label="Fecha (hasta)"
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    @click:clear="clearDateFilters"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filters.date_end"
                  scrollable
                  locale="es"
                  clearable
                  :min="minDateEnd"
                  @input="datepicker_menu_end = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined @click="emitClearAllFilters">
            <small> Limpiar Filtros </small>
          </v-btn>
          <v-btn
            color="red darken-1"
            outlined
            @click="executeCloseModalFilterDocuments"
          >
            <small> Cerrar </small>
          </v-btn>
          <v-btn color="primary" @click="searchFilters">
            <small> Buscar </small>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { preventCloseIfNotKeyEventEsc } from "@/helpers/common";
import moment from "moment";
export default {
  props: {
    modalAction: {
      type: Boolean,
      default: false,
    },
    closeModalFilterDocuments: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      moment,
      datepicker_menu_start: false,
      datepicker_menu_end: false,
      filters: {
        assigned_area_filter: null,
        filter: "",
        onlyFolders: true,
        onlySubFolders: true,
        onlyNameDocuments: true,
        date_start: null,
        date_end: null,
      },
    };
  },
  methods: {
    executeCloseModalFilterDocuments($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.closeModalFilterDocuments($event);
      }
    },
    emitClearAllFilters() {
      this.filters.assigned_area_filter = null;
      this.filters.date_start = null;
      this.filters.date_end = null;
      this.filters.filter = "";
      this.filters.onlyFolders = true;
      this.filters.onlySubFolders = true;
      this.filters.onlyNameDocuments = true;
      this.$emit("clearAllFilters");
    },
    clearDateFilters() {
      this.filters.date_start = null;
      this.filters.date_end = null;
    },
    searchFilters() {
      this.$emit("searchFilters", {
        document_type_filter: null,
        assigned_area_filter: this.filters.assigned_area_filter,
        date_start: this.filters.date_start,
        date_end: this.filters.date_end,
        filter: this.filters.filter,
        onlyFolders: this.filters.onlyFolders,
        onlySubFolders: this.filters.onlySubFolders,
        onlyNameDocuments: this.filters.onlyNameDocuments,
      });
      this.closeModalFilterDocuments(true);
    },
    validateCheckFilter(check_selected) {
      if (
        !this.filters.onlyFolders &&
        !this.filters.onlySubFolders &&
        !this.filters.onlyNameDocuments
      ) {
        if (check_selected == "subfolders") {
          this.filters.onlyFolders = true;
        } else if (check_selected == "name_documents") {
          this.filters.onlyFolders = true;
        } else {
          this.filters.onlySubFolders = true;
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      documentsTypes: "document/documentsTypes",
      assignedAreas: "document/assignedAreas",
    }),
    date_start_formatted() {
      if (this.filters.date_start) {
        return moment(this.filters.date_start).format("DD/MM/YYYY");
      }
      return null;
    },
    date_end_formatted() {
      if (this.filters.date_end) {
        return moment(this.filters.date_end).format("DD/MM/YYYY");
      }
      return null;
    },
    minDateEnd() {
      if (this.filters.date_start) {
        return this.filters.date_start;
      }
      return null;
    },
    maxDateStart() {
      if (this.filters.date_end) {
        return this.filters.date_end;
      }
      return null;
    },
  },
};
</script>

<style></style>
